var render = function render(){var _vm=this,_c=_vm._self._c;return _c('energy-report-preview',_vm._b({staticClass:"ma-n4"},'energy-report-preview',_vm.decoded,false))
}
var staticRenderFns = []

export { render, staticRenderFns }